import {Controller, useFormContext} from "react-hook-form";
import {Input, Space} from "antd";
import {SessionGenInfoSessionCustomCallDurationFormFieldProps} from "../types";
import {FormField, FormFieldError} from "../../../../../../../design-system/form-field";
import {SessionGenInfoFormFields} from "../../types";

export function SessionGenInfoSessionCustomCallDurationFormField({
  id,
  label,
  placeholder,
}: SessionGenInfoSessionCustomCallDurationFormFieldProps) {
  const {control, watch} = useFormContext<SessionGenInfoFormFields>();

  const callDuration = watch("callDuration");
  const isCustomSelected = callDuration === "-1";

  return (
    <div>
      {isCustomSelected && (
        <FormField
          id={id}
          label={label}
          // label="Call duration (In minutes)"
          renderInput={(id) => (
            <Controller
              control={control}
              name="customCallDuration"
              render={({field: {onChange, value, ref, onBlur}, fieldState: {error}}) => (
                <Space direction="vertical" size={16} style={{display: "flex"}}>
                  <Input
                    id={id}
                    status={error?.message ? "error" : ""}
                    onChange={onChange}
                    onBlur={onBlur}
                    size="large"
                    value={value}
                    placeholder={placeholder}
                    ref={ref}
                  />
                  <FormFieldError errorMessage={error?.message} />
                </Space>
              )}
            />
          )}
        />
      )}
    </div>
  );
}
